export interface IEnvVars {
    VITE_API_SERVER: string;
    VITE_API_VERSION: string;
}

export const env: IEnvVars = {
    VITE_API_SERVER: import.meta.env.VITE_API_SERVER,
    VITE_API_VERSION: import.meta.env.VITE_API_VERSION,
};
